import React, {useCallback, useRef, useState} from 'react'
import Text from '@component/Text/Text'
import Span from '@component/Text/Span'
import IconBack from '@svg/common/ic_btn_back.svg'
import IconNext from '@svg/common/ic_btn_next.svg'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import LeaderboardBannerItem from '@feature/leaderboard/components/LeaderboardCarousel/LeaderboardBannerItem'
import {createLog} from '@util/logs'
import {useTranslation} from '@lib/intl/useTranslations'
import useQueryGetBanners from '@hook/query/leaderboard/banner/useQueryGetBanners'

interface IProps {
    className?: string
    contentClassName?: string
}

const LeaderboardCarousel: React.FC<IProps> = ({className, contentClassName}) => {
    const t = useTranslation()
    const [currentIndex, setCurrentIndex] = useState<number>(0)

    const {data} = useQueryGetBanners()

    const onChanged = num => {
        if (num >= 0) {
            setCurrentIndex(num)
        }
    }

    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 7000,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: prev => {
            onChanged(prev)
        },
        useTransform: false,
    }

    const slickRef = useRef<any>()
    const onClickPrevious = useCallback(() => {
        createLog('event', 'leaderboard_banner_prev_button_click')
        slickRef?.current?.slickPrev()
    }, [])
    const onClickNext = useCallback(() => {
        slickRef?.current?.slickNext()
    }, [])

    return (
        <div className={`h-[320px] sm:h-[270px] bg-bg_dark_background w-full ${className}`}>
            <div className={'relative overflow-hidden h-full'}>
                <div className={'min-h-[320px] sm:min-h-[270px]'}>
                    {data?.length > 1 ? (
                        <Slider style={{display: 'grid', backgroundColor: '#000000'}} {...settings} ref={slickRef}>
                            {data?.map(item => (
                                <LeaderboardBannerItem key={item?.id} data={item} />
                            ))}
                        </Slider>
                    ) : (
                        <LeaderboardBannerItem key={data?.at(0)?.id} data={data?.at(0)} />
                    )}
                </div>
                {data && data?.length > 1 ? (
                    <div className={'absolute bottom-[3px] left-[50%] translate-x-[-50%] w-full max-w-[1366px]'}>
                        <div className={'flex justify-end h-fit mb-[10px] pr-[20px] sm:pr-[30px] gap-x-[5px] z-[15]'}>
                            <button
                                className={
                                    'w-[30px] h-[30px] rounded-full bg-white bg-opacity-20 flex items-center justify-center'
                                }
                                onClick={onClickPrevious}>
                                <IconBack className={'fill-white w-[12px]'} />
                            </button>
                            <button
                                className={
                                    'w-[30px] h-[30px] rounded-full bg-white bg-opacity-20 flex items-center justify-center'
                                }
                                onClick={onClickNext}>
                                <IconNext className={'fill-white w-[12px]'} />
                            </button>
                            <Text
                                className={
                                    'text-body2 text-white px-[15px] py-[4.5px] rounded-[15px] bg-white bg-opacity-20 min-w-[50px]'
                                }>
                                <Span className={'font-bold'}>{currentIndex + 1}</Span>/{data?.length ?? 1}
                            </Text>
                        </div>
                    </div>
                ) : (
                    <div />
                )}
            </div>
        </div>
    )
}

export default LeaderboardCarousel
